import BpkSmallNotAllowedIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/not-allowed';
import BpkSmallSearchIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/search';

import './ChartColumn.scss';

type ChartColumnProps = {
  ariaLabel: string;
  index: number;
  showLookupIcon: boolean;
  onClick?: (index: number) => void;
  empty?: boolean;
  heightProportion?: number;
  selected?: boolean;
  outlier?: boolean;
  maxWidthPercent?: number;
  selectable?: boolean;
  scaleValue?: number | string;
  scaleValueFormatter?: (value: number | string) => string;
};

const noopOnClick = () => {};
const defaultScaleValueFormatter = (value: number | string) => `${value}`;

export const ChartColumn = ({
  ariaLabel,
  empty = false,
  heightProportion = 0,
  index,
  maxWidthPercent = 100,
  onClick = noopOnClick,
  outlier = false,
  scaleValue = '',
  scaleValueFormatter = defaultScaleValueFormatter,
  selectable = true,
  selected = false,
  showLookupIcon,
}: ChartColumnProps) => (
  <button
    type="button"
    className={`bar-column ${empty ? ' not-available' : ''} ${
      selected ? ' selected' : ''
    }
      ${!selectable || empty ? ' not-selectable' : ''}`}
    onClick={() => {
      if (selectable && !empty) {
        onClick(index);
      }
    }}
    style={{ maxWidth: `${maxWidthPercent}%` }}
    aria-label={ariaLabel}
    disabled={!selectable || empty}
    aria-pressed={selected}
  >
    <div className="bar">
      {selectable && !empty && !showLookupIcon && (
        <div
          className={`height-indicator${outlier ? ' outlier' : ''}`}
          style={{ height: `${(outlier ? 1 : heightProportion) * 100}%` }}
        />
      )}
      {!selectable && !empty && <BpkSmallNotAllowedIcon className="icon" />}
      {showLookupIcon && !empty && <BpkSmallSearchIcon className="icon" />}
    </div>

    <div className="index" aria-hidden="true">
      {index}
    </div>
    <div className="label" aria-hidden="true">
      {scaleValueFormatter(scaleValue)}
    </div>
    <div className="radio-wrapper" aria-hidden="true">
      {!empty && (
        <span className={`selection-indicator${selected ? ' selected' : ''}`} />
      )}
    </div>
  </button>
);
